// extracted by mini-css-extract-plugin
export default {"bt-input":"CurrencyInputWrapper_bt-input__9EAMW"};